import { connect } from 'react-redux';

import {
  getPriceFilterValues,
  getPreviewNumberOfListings,
  getSearchParams,
} from '../../selectors';
import {
  onChangeFilters,
  toggleFilterPopover,
  loadPreviewNumberOfListings,
  clearPreviewNumberOfListings,
} from '../../actions';

import PriceFilterDesktop from 'ha/components/Filters/PriceFilterDesktop';

export default connect(
  state => ({
    priceFilter: getPriceFilterValues(state),
    previewNumberOfListings: getPreviewNumberOfListings(state),
    searchParams: getSearchParams(state),
  }),
  {
    onChangeFilters,
    toggleFilterPopover,
    loadPreviewNumberOfListings,
    clearPreviewNumberOfListings,
  },
)(PriceFilterDesktop);
